/**
 * @class Fandeck
 */
export default class Fandeck {
    /**
     * @param {Number}  id
     * @param {String}  name
     * @param {String}  displayName
     * @param {Boolean} local
     * @param {Boolean} enabled
     */
    constructor(id, name, displayName, local = false, enabled = true) {
        this._id = id;
        this._name = name;
        this._displayName = displayName;
        this._local = local;
        this._colorCount = 0;
        this._enabled = enabled;

        if (typeof this._id !== "number") {
            throw new Error("Invalid datatype of ID - Fandeck");
        }
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {String}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {String} name
     */
    set name(name) {
        this._name = name;
    }

    /**
     * @return {String}
     */
    get displayName() {
        return this._displayName;
    }

    /**
     * @param {String} displayName
     */
    set displayName(displayName) {
        this._displayName = displayName;
    }

    /**
     * @return {Boolean}
     */
    get local() {
        return this._local;
    }

    /**
     * @param {Boolean} local
     */
    set local(local) {
        this._local = local;
    }

    /**
     * @return {Number}
     */
    get colorCount() {
        return this._colorCount;
    }

    /**
     * @param {Number} colorCount
     */
    set colorCount(colorCount) {
        this._colorCount = colorCount;
    }

    /**
     * @return {Boolean}
     */
    get enabled() {
        return this._enabled;
    }

    /**
     * @param {Boolean} enabled
     */
    set enabled(enabled) {
        this._enabled = enabled;
    }

    /**
     * @return {String}
     */
    toString() {
        return "Fandeck (" + this._id + ")";
    }

    /**
     * @return {String}
     */
    getKey = () => {
        if (this._local) {
            return "local-" + this._id;
        }

        return "default-" + this._id;
    };

    /**
     * @param   {Fandeck}       fandeck
     * @return  {String | null}
     */
    static serialize = (fandeck) => {
        try {
            return (
                fandeck.id +
                ";" +
                (fandeck.name === null ? "null" : fandeck.name.replace(/;/g, "")) +
                ";" +
                (fandeck.displayName === null ? "null" : fandeck.displayName.replace(/;/g, "")) +
                ";" +
                fandeck.local +
                ";" +
                fandeck.enabled
            );
        } catch (e) {
            return null;
        }
    };

    /**
     * @param   {String | null} fandeck
     * @return  {Fandeck | null}
     */
    static unserialize = (fandeck) => {
        if (typeof fandeck !== "string") {
            return null;
        }

        let fandeckParts = fandeck.split(";");

        if (fandeckParts.length !== 5) {
            return null;
        }

        try {
            return new Fandeck(
                Number(fandeckParts[0]),
                fandeckParts[1] === "null" ? null : fandeckParts[1],
                fandeckParts[2] === "null" ? null : fandeckParts[2],
                fandeckParts[3] === "true",
                fandeckParts[4] === "true"
            );
        } catch (e) {
            return null;
        }
    };

    /**
     * Clones Fandeck object and updates colorCount property.
     *
     * @param   {Number} colorCount
     * @return  {Object}
     */
    updateColorCount = (colorCount) => {
        let fandeck = new Fandeck(this._id, this._name, this._displayName, this._local);
        fandeck.colorCount = colorCount;

        return fandeck;
    };

    /**
     * @return {Object}
     */
    formatedObject() {
        return {
            id: this._id,
            name: this._name,
            displayName: this._displayName,
            local: this._local,
            colorCount: this._colorCount,
            enabled: this._enabled
        };
    }
}
